export default Object.freeze({
  /// ---------------------------- Menu Bar ------------------------- 
  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matrix",
  OSCILLOSCOPE: "Oscilloscope",
  BAR_GRAPH: "Bar Graph",
  REPORT: "Report",
  INFOS: "Schedule",
  RESUME: "Summary",
  LOG: "Log",
  CONFIG: "Settings",

  SAVE: "Save",
  REMOVE: "Remove",

  // ---------------------------- Live List ----------------------------
  TIME_ON: "Analysis time: ",

  GOOD_STRING: "Good",
  ATTENTION_STRING: "Attention",
  BAD_STRING: "Bad",
  NO_SIGNAL_STRING: "No signal",
  UNKNOWN_STRING: "Unknown",

  REASON: "\nReason: ",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filter by address or signal",

  ADDRESSES: "Addresses",
  ADDRESS: "Address",
  AMPLITUDE: "Amplitude",
  AMPLITUDE_PRE: "Preamble amplitude",
  MEAN_AMPLITUDE: "Average amplitude",
  MEAN_AMPLITUDE_N: "Average\namplitude",
  MIN_AMPLITUDE: "Minimum amplitude",
  MIN_AMPLITUDE_N: "Minimum\namplitude",
  MAX_AMPLITUDE: "Overshoot",
  NOISE: "Noise",
  SIGNAL: "Signal",
  RATIO: "Ratio",
  NETWORK_TAG: "Segment tag",
  IS_IN_SEGMENT: "Belongs to\nSegment?",
  IS_IN_SEGMENT_1: "Belongs to",
  IS_IN_SEGMENT_2: "Segment?",
  IS_IN_SEGMENT_DP: "Belongs to Segment: ",
  IS_IN_SEGMENT_QUESTION: "Belongs to Segment?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indicates whether the device belongs to the same segment as this TS Scope DP.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "This option must be adjusted manually for each device on the settings screen.",

  MIN_AMPLITUDE_1: "Minimum",
  MIN_AMPLITUDE_2: "amplitude",

  MEAN_AMPLITUDE_1: "Average",
  MEAN_AMPLITUDE_2: "amplitude",

  RESPONSE_TIME_1: "response",
  RESPONSE_TIME_2: "time",
  CURRENT: "Current",
  MINIMUM: "Minimum",
  MAXIMUM: "Maximum",

  RESPONSE_TIME: "Current\nresponse\ntime",
  MIN_RESPONSE_TIME: "Minimum\nresponse\ntime",
  MAX_RESPONSE_TIME: "Maximum\nresponse\ntime",

  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "This column is an indicator of problems on channel A, green wire, such as:",
  CHANNEL_B_PROBLEM: "This column is an indicator of problems on channel B, red wire, such as:",
  MASTERS: "Masters",
  SLAVES: "Slaves",
  AMPLITUDE_IDLE: "Idle voltage ",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  NETWORK_DATA: "Network data",

  MODAL_TITLE: "Characteristic waveforms",

  TURNED_ON: "On",
  TURNED_OFF: "Off",

  ANALYSIS_ERROR: "An error occurred while changing the analysis state",

  ANALYSIS: "Analysis",
  ANALYZER: "TS Scope DP ",

  DETECTED_PROBLEMS: "Detected problems:",
  INIT_PICO_NOT_FOUND: "TS Scope DP not found. Please connect it to the computer.",
  INVERTED_AB: "Cables A and B are inverted.",
  MONGO_OFF: "Database error. Close the program and open it again. If the error persists, click the button below.",
  PICO_NOT_FOUND: "The TS Scope DP is disconnected. After reconnecting it, the program must be restarted.",
  MONGO_REPAIR_SUCCESS: "Error repaired successfully! Please close the program and open it again for the changes to take effect.",
  MONGO_REPAIR_ERROR: "The problem could not be solved. Please contact support.",
  INIT_PICO_NOT_FOUND_PLAY: "Error starting TS Scope DP. Please disconnect it from your computer, reconnect it, and restart the program. If the error persists, restart the computer and try again.",

  REPAIR: "Repair",
  LOADING_ANALYZER: "Starting TS Scope DP, please wait.",

  NO_DP_ACTIVE_NETWORK: "The TS Scope DP did not find an active network. Make sure it is correctly connected to a PROFIBUS DP network and try again.",

  INVALID_SERIAL: "The serial number does not match this TS Scope DP. Please reinstall the program with a valid serial number.",
  INVERTED_AB_POPUP: "Cables A and B are inverted.\nPlease swap the cables back and press Play again.",

  MONGO_OFF_POPUP: "Error initializing the database. Click the button below to repair the problem.",

  MEAN_AMPLITUDE_DESC: "Amplitude value measured between the average of the points at logic high level and the average of the points at logic low level, as shown in the figure below.",
  MEAN_AMPLITUDE_DESC_2: "High average amplitude indicates a lack of terminators. When it is low, it indicates: resistance in the connections; too many terminators; crimped cables; crushed or bent cables, etc.",
  AMPLITUDE_MIN_DESC: "Amplitude value between the lowest point of the waveform at logic high level and the highest point at logic low level, as shown in the figure below.",
  AMPLITUDE_MIN_DESC_2: "A large difference between the average and minimum amplitude indicates: reflection (terminators); long cable; noise; moisture on the bus, etc.",
  OVERSHOOTING_DESC: "Amplitude value between the average value of the waveform at logic high level and the highest point at logic high level, as shown in the figure below.",
  OVERSHOOTING_DESC_2: "Indicates: lack of terminators; connections in the middle of the bus; branches, etc.",
  RATIO_DESC_1: "Ratio between the minimum amplitude and average amplitude values, intended to make signal degradation evident.",
  RATIO_DESC_2: "The closer to 1, the better; and the closer to 0 (zero), the worse the signal quality.",
  RATIO_FOMULA: "Ratio = Min. amp. / Avg. amp.",

  IDLE_DESCRIPTION: " Period in which the network is idle, that is, the period between a master request and the slave response, or between master packets to itself. The ideal idle voltage is 1V; different values indicate network problems.",

  MONITOR_IP_NOT_FOUND: "Monitor IP not found",

  CHANNEL_DESCRIPTION_1: "Short circuit;",
  CHANNEL_DESCRIPTION_2: "Loose terminal;",
  CHANNEL_DESCRIPTION_3: "Broken cable;",
  CHANNEL_DESCRIPTION_4: "Or another problem that damages the communication signal.",

  SIGNAL_QUALITY: "Signal quality",
  SIGNAL_QUALITY_DESCRIPTION_1: "In the “Signal” column, the worst case is always considered for average and minimum amplitude.",

  GOOD: "Good",
  GOOD_DESCRIPTION_1: "• Average Amplitude from 4 to 7 V",
  GOOD_DESCRIPTION_2: ". Signal with good amplitude!",

  ATTENTION: "Attention - Preventive action",
  ATTENTION_DESCRIPTION_1: "• Average amplitude from 7 to 8 V",
  ATTENTION_DESCRIPTION_2: ". May indicate a lack of terminators.",
  ATTENTION_DESCRIPTION_3: "• Average amplitude from 3 to 4 V",
  ATTENTION_DESCRIPTION_4: ". May indicate resistance on the bus, too many terminators, connection problems, loose terminals, slave problem, etc.",

  BAD: "Bad - Corrective action",

  BAD_DESCRIPTION_1: "• Average amplitude less than 3 V",
  BAD_DESCRIPTION_2: " or greater than 8 V",
  BAD_DESCRIPTION_3: ", may cause PROFIBUS packet loss.",
  BAD_DESCRIPTION_4: "• Minimum amplitude less than 3 V",
  BAD_DESCRIPTION_5: " may cause PROFIBUS packet loss.",

  LIGHT_TONES: "Light tones",
  LIGHT_TONES_DESCRIPTION: "• The TS Monitor PROFIBUS PRO is not finding a slave response, so the software keeps the measurements from the last capture and uses a light tone to indicate that the data is not being updated.",


  IDLE: "Idle:",
  TENSAO_IDLE_POPUP_1: "If the idle voltage is less than 0.6 V, the value will be highlighted in orange.",
  TENSAO_IDLE_POPUP_2: "Only the idle voltages of the active channels will appear here. To change which channels are currently active, go to the 'ACTIVE CHANNELS' section on the settings screen.",
  PS: "NOTE",

  YEAR: " year",
  MONTH: " month",
  MONTHS: " months",
  DAY: " day",
  HOUR: " hour",
  MINUTE: " minute",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Chart",
  A_AND_B: "A and B",
  B_A: "B - A",
  WAVE_FORM: "Waveform",
  AMPLITUDE_A: "Amplitude A",
  AMPLITUDE_B: "Amplitude B",
  ADDRESS_DP: "Address: ",
  WAVE_A: "Signal A",
  WAVE_B: "Signal B",
  WAVE_B_A: "Signal B - A",
  WAVE_PA: "Signal DP",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Time (ns)",
  TIME_US: "Time (μs)",
  TIME_MS: "Time (ms)",
  TIME_S: "Time (s)",

  AMPLITUDE_PLACEHOLDER: "0.0 V",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursors",
  CONTROLS: "Controls ",
  TIME_INTERVAL: " time",
  CONTROLS_POPUP_TEXT: "After pressing PLAY, the waveform is updated approximately every 200 milliseconds.",
  CONTROLS_POPUP_TEXT_2: "To release the controls, you must select manual view and choose a device.",

  SIZE: "Size ",
  VISUALIZATION: "Visualization",
  AUTOMATIC: "Automatic",
  MANUAL: "Manual",

  STD_WAVE_FORM: "Standard waveform",
  LONG_CABLE_WAVE_FORM: "Typical long-cable waveform",
  EXCESS_TERMINATIOR_WAVE_FORM: "Typical waveform with excess terminator",
  NO_SLAVE_WAVE_FORM: "Typical waveform with no slave (disconnected devices)",
  REFLECTION_WAVE_FORM: "Typical waveform with reflection",
  NO_TERMINATOR_WAVE_FORM: "Typical waveform with missing terminator",
  FOR_MORE_INFO_DP: "For additional information, consult Toledo & Souza or the PROFIBUS International guidelines. It is worth noting that the events shown may occur together, which changes the patterns displayed.",
  FEW_TERMINATOR_WAVE_FORM: "Typical waveform with too few terminators",

  WAVE_SIZE_DESC_1: "The TS Scope DP already samples the frame in two modes: with only 1 Byte or with 3 Bytes, so here we can view with greater zoom at 1 Byte or lower zoom at 3 Bytes.",
  WAVE_SIZE_DESC_2: "There is one exception: the “E5” frame – short acknowledgement – has only 1 Byte, always.",
  WAVE_SIZE_DESC_3: "Below is an example in a frame with more than 1 and 3 Bytes.",

  TS_SCOPE_NOT_FINDING_ANSWER: "The TS Scope DP is not finding a slave response, so the data is outdated. The waveform below is the last one captured by the system.",

  TIME_DP: "Time: ",
  PS_1: "Note 1:",
  PS_2: "Note 2:",
  PS_3: "Note 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Order by",
  AMPLITUDE_ASC: "Ascending amplitude",
  AMPLITUDE_DESC: "Descending amplitude",
  ADDRESS_ASC: "Ascending address",
  VOLTAGE_V: "Voltage (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Voltage (V)",
  VOLTAGE_MV: "Voltage (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Voltage (mV)",
  ORDER: "Sorting",
  REFRESH_DATA: "Refresh data",
  LOADING: "Loading",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Please enter a valid event type.",
  BEFORE_MONITOR_INIT_STR: "Before the last initialization",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filter by event type",
  LOG_WAITING: "Loading log data",
  TYPE: "Type",

  TERMINATION_OFF_LOG_DESCRIPTION: "TS Expert detected a possible missing terminator on the network.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "TS Expert detected a possible lack of power supply to the terminator.",
  HIGH_RESISTANCE_LOG_DESCRIPTION: "TS Expert detected possible excess terminators or high resistance on the PROFIBUS bus.",
  A_NOT_OK_LOG_DESCRIPTION: "TS Expert detected a possible short circuit between conductor A and the shield braid, or the grounded mass of a panel or slave.",
  B_NOT_OK_LOG_DESCRIPTION: "TS Expert detected a possible short circuit between conductor B and the shield braid, or the grounded mass of a panel or slave.",
  LONG_CABLE_LOG_DESCRIPTION: "TS Expert detected a possible bus condition with a length greater than allowed.",
  NOISE_LOG_DESCRIPTION: "TS Expert detected a possible noise condition on the PROFIBUS network.",
  REFLECTION_LOG_DESCRIPTION: "TS Expert detected reflection in the waveform.",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "TS Expert detected a possible voltage level failure (Action Required).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "TS Expert detected a possible voltage level failure (Urgent Action).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "TS Expert detected a possible relay failure.",
  EVENT_CHECKED_SUCCESS: "The event was cleared successfully.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME: "TS Scope DP Report",
  HEADER_TEXT: "TS Scope DP",
  GENERATE_REPORT: "Generate report",

  ANALYZER_VERSION_STRING: "- TS Scope DP version:",
  ANALYZER_VERSION: "6.0.1",

  PROTOCOL: "- Protocol:",
  PROTOCOL_TYPE: "PROFIBUS DP",

  ANALYSIS_INIT: "- Analysis start time:",
  REPORT_GENERATION: "- Report generation time:",
  ANALYSIS_DURATION: "Analysis duration until report generation:",

  GENERAL_REPORT: "General report – TS Scope DP",
  DATA_REPORT: "Data report – TS Scope DP",

  CLIENT_INFO: "Client information",
  EXECUTING_COMPANY_INFO: "Executing company information",
  CONFORMITY: "Conformity",
  REPORT_TYPE: "Report Type",
  ANNOTATIONS: "Notes",
  CONCLUSION: "Conclusion",

  DROPDOWN_PLACEHOLDER: "Choose an option",
  CONFORM: "Conforming",
  CONFORM_W_RESTRICTION: "Conforming with restrictions",
  NON_CONFORM: "Non-Conforming",

  PROJECT_NAME: "- Project name:",
  NETWORK_NAME: "- Network name:",
  LOCATION: "- Location:",
  COMPANY_NAME: "- Company name:",
  ACCOUNTABLE_NAME: "- Responsible person's name:",
  COMPANY_ADDRESS: "- Address:",
  COMPANY_CITY: "- City:",
  COMPANY_TEL: "- Telephone:",

  EXECUTING_COMPANY_NAME: "- Company name:",
  EXECUTING_ACCOUNTABLE_NAME: "- Responsible person's name:",
  EXECUTING_TEL: "- Telephone:",
  EXECUTING_EMAIL: "- Email:",

  SUMMARY: "Summary",

  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2. - Oscilloscope",
  A_BAR_GRAPH_PAGE_TITLE: "3. - Bar Graph",
  A_LOG_PAGE_TITLE: "4. - Event Log",

  ANALYSIS_INFO: "Analysis information",
  GENERATED_BY: "- Generated by TS Scope DP",
  HARDWARE_VERSION: "- Hardware version:",
  SOFTWARE_VERSION: "- Software version:",
  DATE_TIME: "- Date and time:",
  BAUD_RATE: "- Baud rate:",
  CYCLE_TIME: "- Cycle time:",
  NUM_MASTERS: "- Masters:",
  NUM_SLAVES: "- Slaves:",
  AMPLITUDE_IDLE_1: "- Idle voltage:",
  SEGMENT_TAG: "- Segment tag:",

  ETHERNET_INFO: "ETHERNET information",

  IP_DP: "- IP: ",
  MASK_DP: "- Mask: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Network name: ",

  LIVE_LIST_DOTS: "........................................................................................................................................",
  BAR_DOTS: ".....................................................................................................................................",
  OSC_DOTS: "................................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  DISCLAIMER_DOTS: "..........................................................................................................................",

  GENERATING_REPORT_WAITING: "Generating report, please wait.",
  GENERATING_REPORT_WAITING_1: "This procedure is taking longer than usual.",
  GENERATING_REPORT_WAITING_2: "This procedure is taking longer than usual, please keep waiting.",
  GENERATING_REPORT_SUCCESS: "Report generated successfully. To save it, click save report below.",

  SELECT_REPORT_TYPE: "Please select a report type",

  MASTER_DP: "Master: ",
  SLAVE_DP: "Slave: ",
  SIGNAL_DP: "Signal: ",
  AMPLITUDE_DP: "Amplitude: ",
  AMPLITUDE_PRE_DP: "Preamble amplitude: ",
  AMPLITUDE_MIN_DP: "Minimum amplitude: ",
  OVERSHOOTING_DP: "Overshoot: ",
  AMPLITUDE_MAX_DP: "Maximum amplitude: ",
  MODEL: "Model",

  HORARY: "Time",
  DESCRIPTION: "Description",
  GENERAL_INFORMATION: "General information",
  LAST_200_EVENTS: "Last 200 events",

  END_OF_REPORT: "End of report",
  DISCLAIMER: "Legal disclaimer",
  DISCLAIMER_TEXT: "The data and values presented in this report are merely auxiliary for the PROFIBUS specialist, so any correction indication must be made by the user. For this reason, monitoring by a certified PROFIBUS engineer or technician responsible for the analysis is recommended to attest to the information provided by the product. Therefore, Toledo & Souza disclaims any liability, losses or damages, direct or indirect, caused by interpretations of the software, and offers no warranty regarding the integrity, quality or suitability of the information provided, as it depends on the technical analysis of a qualified professional. In the absence of such a professional, the user assumes the risk that the content may be inaccurate, incomplete, or may not meet their needs and requirements.",

  CAPTURE_TIME: "Capture time",

  PROJECT_NAME_LABEL: "Project name",
  NETWORK_LABEL: "Network name",
  LOCATION_LABEL: "Location",
  COMPANY_NAME_LABEL: "Company name",
  ACCOUNTABLE_NAME_LABEL: "Responsible person's name",
  CITY_LABEL: "City",
  TEL_LABEL: "Telephone",
  CLIENT_LOGO_LABEL: "Client logo",
  EMAIL_LABEL: "E-mail",
  EXECUTING_COMPANY_LOGO_LABEL: "Executing company logo",
  FINISHING: "Finishing...",
  SAVE_REPORT: "Save report",
  SLAVE_NOT_FOUND_SHOWING_LAST_WAVEFORM: "Could not find the slave on the network, showing the last captured waveform.",
  REPORT_SCOPE_DP: "Report - TS Scope DP",
  MASTER: "Master ",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Login",
  LOGOUT: "Logout",
  TEST_NETWORK: "Test network",
  TIMEZONE: "Timezone",
  RESTART_SYSTEM: "Restart System",
  IP: "IP",
  MASK: "Mask",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  TAGS: "Tags",
  SETUP: "Configure",
  EDIT: "Edit",
  SOFTWARE_UPDATE: "Software Update",
  INTERFACE_CONFIG: "Interface Settings",
  CURRENT_VERSION: "Current version: ",
  UPDATE: "Update",
  USER: "User",
  NEW_PASSWORD: "New password",
  REPEAT_PASSWORD: "Repeat password",
  ALTER_LOGIN: "Change login",
  ARE_YOU_SURE_ALTER_CONFIG: "Are you sure you want to change the TS Scope DP Ethernet settings?",
  INVALID_OR_CORRUPT_FILE: "The file is not valid or is corrupted.",
  IMPORT: "Import",
  EXPORT: "Export",
  LOGIN_CREDENTIALS_FAILURE: "An error occurred while logging in: incorrect username or password.",
  LOGIN_GENERAL_FALIURE: "An error occurred while logging in:",

  GPG_ALERT_MESSAGE: "Only files with the .gpg extension can be sent",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "The file was sent successfully.",
  SEND_FILE_SUCCESS_WARNING: "Do not forget to check that your computer's network card is on the same subnet as the IP: ",
  SEND_FILE_FAILURE: "An error occurred while sending the file.",
  SEND_FILE_WAITING: "Sending the file.",
  SEND_FILE_WRONG_FILENAME: "Invalid name. The update file must be named: updateRMDP.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "The update file was corrupted during upload.",
  SEND_CONFIG_SUCCESS: "The settings were sent successfully.",
  SEND_CONFIG_FAILURE: "An error occurred while sending the settings.",
  SEND_CONFIG_WAITING: "Sending the settings.",
  SEND_CONFIG_WAITING_2: "Finishing sending the settings.",
  SEND_CONFIG_DONE: "Settings sent.",
  START_MESSAGE_SUCCESS: "The monitor will start in 15 seconds.",
  START_MESSAGE_FAILURE: "An error occurred while starting the monitor.",
  STOP_MESSAGE_SUCCESS: "The monitor will stop in 15 seconds.",
  STOP_MESSAGE_FAILURE: "An error occurred while stopping the monitor.",
  CLEAN_STATISTICS_SUCCESS: "The statistics were cleared successfully.",
  CLEAN_STATISTICS_FAILURE: "An error occurred while clearing the statistics.",
  RESET_TRAFFIC_SUCCESS: "The values will be reset on the next scan.",
  RESET_TRAFFIC_FAILURE: "An error occurred while resetting the error increments.",
  RESET_DEVICES_SUCCESS: "The device data was cleared successfully.",
  RESET_DEVICES_FAILURE: "An error occurred while clearing the device data.",
  CHANGE_USERNAME_SUCCESS: "The username was changed successfully. Please log in again.",
  CHANGE_USERNAME_FAILURE: "An error occurred while changing the username: ",
  USERNAME_TOO_SHORT: "The username must contain at least one character.",
  PASSWORD_MISSMATCH: "The entered passwords do not match",
  CHANGE_PASSWORD_SUCCESS: "The password was changed successfully. Please log in again.",
  CHANGE_PASSWORD_FAILURE: "An error occurred while changing the password: ",
  RESET_RETRIES_SUCCESS: "The retries were cleared successfully.",
  RESET_RETRIES_FAILURE: "An error occurred while clearing the retries.",

  VERIFY_THE_FOLLOWING_INFO: "Please check the following information:",
  INVALID_IP: "\n- The entered IP is invalid",
  INVALID_SUBMASK: "\n- The entered subnet mask is invalid",
  INVALID_GATEWAY: "\n- The entered gateway is invalid",
  INVALID_DNS: "\n- The entered DNS is invalid",
  LOOPBACK_IP: "\n- The loopback IP (127.0.0.1) cannot be used as the TS Scope DP IP",
  LOOPBACK_IP_NTP: "\n- The loopback IP (127.0.0.1) cannot be used as the NTP server IP",
  TAG_TOO_LONG: "\n- The tag length cannot exceed 30 characters",
  EMPTY_WIFI_PWD: "\n- The Wi-Fi password cannot be empty",
  SELECT_TIMEZONE: "\n- A Timezone must be selected to configure the NTP server",
  SUBNET_OVERLAP_WLAN: "\n- TS Scope DP detected that there is an overlap in addresses between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the WLAN with the chosen IP address and mask.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Scope DP has detected that there is an overlapping address between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the ETHERNET interface with the chosen IP address and mask.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 cannot be used as the the TS Scope DP's IP",
  ZERO_IP_MASK_MSG: "\n- The IP 0.0.0.0 cannot be used as a network mask",
  BROADCAST_IP_MSG: "\n- The network broadcast IP cannot be used as the TS Scope DP's IP",
  NETWORK_IP_MSG: "\n- Network IP cannot be used as TS Scope DP's IP",
  BROADCAST_GATEWAY_MSG: "\n- The network broadcast IP cannot be used as the gateway IP",
  NETWORK_GATEWAY_MSG: "\n- The network IP cannot be used as the gateway IP",

  ALTER_USERNAME: "CHANGE USERNAME",
  ALTER_PASSWORD: "CHANGE PASSWORD",

  SYSTEM: "System",
  RESTART: "Restart",
  CONFIRM_RESTART_SYSTEM: "Are you sure you want to restart the system?",
  RESTART_SYSTEM_FAILURE: "An error occurred while trying to restart the system.",
  RESTART_SYSTEM_SUCCESS: "Restart request sent successfully. Wait about 3 minutes for the system to restart completely.",

  SELECT_FILE: "Please select a file to be sent",
  SELECT_GSD_FLIE: "Please select at least one GSD file to be sent",
  SENDING_GSD_FILES: "Sending GSD files",

  DO_NOT_CLOSE_THIS_TAB: "Keep this tab open to follow the update.",
  UPDATING_MONITOR_FILES: "Updating files on the TS Scope DP. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Files updated, preparing to restart the TS Scope DP.",
  RESTARTING_MONITOR_WAIT: "Restarting the TS Scope DP, please wait a few minutes.",
  UPDATE_SUCCESS: "The update was completed successfully!",
  UPDATE_ERROR_STRING: "The following error occurred while updating the TS Scope DP: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Change at least one of the fields to update the interface settings.",
  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• The TS Scope DP IP was changed successfully.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• The note was changed successfully.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRemember to update the browser address to: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "The interface settings were updated successfully!",

  ALTER: "Change",
  NO: "No",
  YES: "Yes",

  NOTE: "Note",
  MONITOR_IP: "Monitor IP",

  IN_SEGMENT_DEVICES: "Segment devices",
  UPDATING_DATA: "Updating information, please wait",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filter devices by address",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "List of devices belonging to the same segment as the TS Scope DP.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "If the device is unchecked in this list, it means that it does not belong to the same segment as the TS Scope DP.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "If it does not belong to the same segment, the waveform viewed in the oscilloscope may not correspond to the device's actual waveform.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "Are you sure you want to make changes to the list of devices belonging to the segment?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "An error occurred while changing the segment device list.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "The segment device list was changed successfully!",

  TS_EXPERT_CONFIG_POPUP: "Allows you to enable/disable non-conformities to be reported by the tool.",

  SEND_NTP_CONFIG_WAITING: "Sending NTP server settings.",
  SEND_NTP_CONFIG_DONE: "NTP server settings sent.",

  NTP_SERVER: "NTP Server",

  TURN_NTP_SERVER_ON: "Turn NTP server on",
  TURN_NTP_SERVER_ON_QUESTION: "Are you sure you want to turn on the NTP server? The TS Scope DP will need to be restarted for this.",

  PROCESSING_NTP_INIT: "Starting processing of NTP server information",
  PROCESSING_NTP_INFO: "Processing NTP server information.",
  PROCESSED_NTP_INFO: "NTP server information processed.",
  PROCESSING_NTP_ERROR: "An error occurred while sending information to the NTP server. Check that the server IP address is correct. If it is, also check that the NTP service is on and try again.",

  NTP_INFO_TURNED_ON_SUCCESS: "The NTP server was turned on successfully.",
  NTP_INFO_TURNED_ON_FAILURE: "An error occurred while turning on the NTP server.",
  NTP_INFO_FAILURE: "Failed to synchronize with the server. If the error persists, contact the NTP server administrator.",
  TURN_ON_DATE: "\nThe server time was updated to: ",

  MONITOR_WILL_BE_RESTARTED: "\nThe TS Scope DP will be restarted now,",
  MONITOR_RESTART_SUCCESS: "The TS Scope DP was restarted successfully.",
  MONITOR_RESTART_FAILURE: "An error occurred while restarting the TS Scope DP.",

  NTP_INFO_TURNED_OFF_SUCCESS: "The NTP server was turned off successfully.",
  NTP_INFO_TURNED_OFF_FAILURE: "An error occurred while turning off the NTP server.",
  TURN_OFF_DATE: "\nShutdown time: ",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Ethernet interface configuration field.",
  ETHERNET_POPUP_2: "Used for supervision and Web access to TS Scope DP data.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Wireless interface configuration field, when an adapter is available.",
  WLAN_POPUP_2: "Used for supervision and Web access to TS Scope DP data.",

  TAG_CONFIG: "Segment tag",

  TAG_WAS_CHANGED_SUCCESSFULLY: "The TS Scope DP tag was changed successfully.",
  TAG_CHANGE_FAILURE: "An error occurred while changing the TS Scope DP tag.",

  INVALID_MONITOR_IP: "The entered monitor IP is invalid.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "The monitor IP was changed successfully.",
  MONITOR_IP_CHANGE_FAILURE: "An error occurred while changing the monitor IP.",

  WAITING: "Please wait a moment",
  CLEAN_LOG_SUCCESS: "The log was cleared successfully.",
  CLEAN_LOG_FAILURE: "An error occurred while clearing the log.",
  CLEAR: "Clear",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "Are you sure you want to change the hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "The monitor must be restarted for this.",
  HOSTNAME_POPUP_1: "A hostname must be between 2 and 64 characters long to be valid.",
  HOSTNAME_POPUP_2: "Additionally, it can only contain letters, numbers, periods, and hyphens, and must begin and end with letters and numbers only.",
  INVALID_HOSTNAME_1: "The hostname must be between 2 and 64 characters long.",
  INVALID_HOSTNAME_2: "The hostname must contain only letters, numbers, periods, and hyphens, and must begin and end with only letters and numbers.",
  HOSTNAME_CONFIG_SUCCESS: "The hostname has been configured successfully.",
  HOSTNAME_CONFIG_ERROR: "An error occurred while configuring the hostname",
  MODE: "Mode",
  HIDDEN_SSID: "Hidden SSID",
  OPTIONAL: " (Optional)",

  HOSTNAME: "Hostname",

  ALTER_MONITOR_WLAN_CONFIG: "Are you sure you want to change the WLAN settings of the TS Scope DP?",

  FIXED_IP: "Fixed IP",

  CHANGE_IDLE_SIZE: "Change idle size",
  CHANGE_IDLE_SIZE_QUESTION_1: "Changing the idle size will restart the internal procedures of the TS Monitor PROFIBUS PRO. This procedure may take up to 3 minutes.",
  CHANGE_IDLE_SIZE_QUESTION_2: "After clicking yes, wait on the screen until it finishes. Are you sure you want to proceed?",

  CHANGE_PACKET_SIZE: "Change packet size",
  CHANGE_PACKET_SIZE_QUESTION_1: "Changing the packet size will restart the TS Scope DP internal procedures. This procedure may take up to 3 minutes.",
  CHANGE_PACKET_SIZE_QUESTION_2: "After clicking yes, wait on the screen until it finishes. Are you sure you want to proceed?",

  ASK_PROCEED: "Are you sure you want to proceed?",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Add/Change Tags",
  CHOOSE_DEVICE: "Choose a device",
  NEW_TAG: "New TAG",
  REMOVE_ALL_TAGS: "Remove all Tags",
  CONFIRM_REMOVE_ALL_TAGS: "Are you sure you want to remove the tags from all devices?",
  CHANGE_TAG_SUCCESS: "The tag was changed successfully.",
  CHANGE_TAG_FAILURE: "An error occurred while changing the tag",
  REMOVE_TAG_SUCCESS: "The tags were removed successfully.",
  REMOVE_TAG_FAILURE: "An error occurred while removing the tags",
  IMPORT_TAGS_SUCCESS: "The tags were imported successfully",
  IMPORT_TAGS_FAILURE: "An error occurred while importing the tags: ",
  PLEASE_SELECT_TAG_FILE: "Please select a tag file.",
  IMPORT_TAGS: "Import tags",
  EXPORT_TAGS: "Export tags",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Updating TS Expert settings, please wait a moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "The TS Expert settings were saved successfully.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "An error occurred while saving the TS Expert settings.",

  TS_EXPERT_CONFIGURATION: "TS Expert Settings",

  TERMINATION_OFF_LIST_HEADER: "Terminator in OFF position",
  TERMINATION_OFF_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible missing terminator on the network.",

  NO_POWER_SUPPLY_LIST_HEADER: "Terminator without power supply",
  NO_POWER_SUPPLY_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible lack of power supply to the terminator.",

  HIGH_RESISTANCE_LIST_HEADER: "Attenuated signal",
  HIGH_RESISTANCE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate possible excess terminators or high resistance on the PROFIBUS bus.",

  A_NOT_OK_LIST_HEADER: "Short between conductor A and the shield",
  A_NOT_OK_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible short circuit between conductor A and the shield braid or the grounded mass of a panel or slave.",

  B_NOT_OK_LIST_HEADER: "Short between conductor B and the shield",
  B_NOT_OK_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible short circuit between conductor B and the shield braid or the grounded mass of a panel or slave.",

  LONG_CABLE_LIST_HEADER: "Long cable",
  LONG_CABLE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible bus condition with a length greater than allowed.",

  NOISE_LIST_HEADER: "Noise or low insulation (leakage to ground)",
  NOISE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible noise condition on the PROFIBUS network.",

  REFLECTION_LIST_HEADER: "Waveform reflection",
  REFLECTION_LIST_CONTENT: "When this option is enabled, TS Expert will indicate the presence of reflection in the waveform.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Optic fiber link – Voltage level failure (Action Required)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "When this option is enabled, TS Expert will indicate low voltage at the analog outputs that indicate the quality of the signal received by the fiber link. This value can be configured by the user on the TS Scope/Monitor PRO settings screen.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Optic fiber link – Voltage level failure (Urgent Action)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate low voltage at the analog outputs that indicate the quality of the signal received by the fiber link. This value can be configured by the user on the TS Scope/Monitor PRO settings screen.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Optic fiber link – Relay failure",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "When this option is enabled, TS Expert will show a fiber link failure indicated by relay, which must be connected to the TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT: "Action list",

  TS_EXPERT_REPORT_EXPORT_NAME: "Action list - TS Expert - TS Scope DP",

  TS_EXPERT_POPUP_1: "This tab displays TS Expert information.",
  TS_EXPERT_POPUP_2: "This tool is an expert system developed to optimize and accelerate the analysis of the main discrepancies detected by TS Scope DP in PROFIBUS networks.",
  TS_EXPERT_POPUP_3: "In an automated way, maintenance, engineering and related teams can obtain a list of actions with different events, their possible causes, solution suggestions and the devices where they were detected.",
  TS_EXPERT_POPUP_4: "The use of TS Expert does not eliminate the need for human analysis, nor does it replace human capabilities to create data correlations and interpretation.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detected on: ",
  CHECK_YOUR_NETWORK: "Please check your network.",

  EXPORT_ACTIONS_LIST: "Export action list",
  GENERATING_ACTIONS_LIST_WAITING: "Generating action list PDF, please wait.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generated successfully. To save it, click on save action list.",

  EVENTS_LIST: "List of events",
  ACTIONS: "Actions",

  NO_PROBLEM_DETECTED: "TS Expert did not detect any event on the network.",
  NO_EVENTS_TO_BE_ANALYZED: "There are no events to be analyzed.",

  NO_EVENT_SELECTED: "No events selected",
  CHOOSE_AN_EVENT: "Select an event to view suggested actions.",

  DETAILING: "Details",

  CHECKED: "Clear",
  BATCH_CHECK: "Clear all",

  PROBLEM_CHECKED: "The event was cleared successfully",
  PROBLEM_CHECK_ERROR: "An error occurred while clearing the event.",

  QUANTITY_DP: "Quantity: ",
  INCREMENTS: "Increments",

  PORT_IS_STILL_INACTIVE: "The port is still inactive",
  MARK_PROBLEM_AS_SOLVED: "Are you sure you want to mark the event as cleared?",

  LAST_UPDATED: "Last updated on: ",
  THIS_COMPUTER_TIME: " (This computer's time)",

  DEVICE: "Device",
  DEVICES: "Devices",
  UNKNOWN: "Unknown",

  // ---------------------------- TERMINADOR OFF ----------------------------
  TERMINATION_OFF_SUGGESTION_1: "When the terminator is in the OFF position, the suggestion is to:",
  TERMINATION_OFF_SUGGESTION_2: "Visually check:",
  TERMINATION_OFF_SUGGESTION_3: "Whether the terminators at both ends of the segment are in the \"on\" position;",
  TERMINATION_OFF_SUGGESTION_4: "If PROFIBUS connectors are not used, check whether there is an active terminator at both ends;",
  TERMINATION_OFF_SUGGESTION_5: "If there is no terminator at one of the ends, it must be installed.",
  TERMINATION_OFF_SUGGESTION_6: "It is recommended to wait for a shutdown or schedule with production before turning on the disabled terminator or installing an active terminator, since this change may bring down the network.",

  // ---------------------------- NO POWER SUPPLY ----------------------------
  NO_POWER_SUPPLY_SUGGESTION_1: "When the terminator has no power supply, the suggestion is to:",
  NO_POWER_SUPPLY_SUGGESTION_2: "Check the power supply of the active terminators (when the device is installed) and check the power supply for terminators on the slave or master at the DB9 connector pins, as follows:",
  NO_POWER_SUPPLY_SUGGESTION_3: "In the case of an active terminator, simply power it; but in the case of a DB9 connector, it is necessary to check whether the problem is in the connector or in the power supply coming from the slave or master.",
  NO_POWER_SUPPLY_SUGGESTION_4: "It is recommended to perform these procedures with production stopped, since this change may bring down the network.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  HIGH_RESISTANCE_SUGGESTION_1: "When the signal is attenuated, the suggestion is to:",
  HIGH_RESISTANCE_SUGGESTION_2: "Check:",

  HIGH_RESISTANCE_SUGGESTION_3: "Whether any equipment in the segment has its internal terminator turned on;",
  HIGH_RESISTANCE_SUGGESTION_4: "If no equipment has an internal terminator turned on, check the slave electronics by isolating them individually from the bus;",
  HIGH_RESISTANCE_SUGGESTION_5: "Check for loose terminals in terminal connections or terminal-block connectors;",
  HIGH_RESISTANCE_SUGGESTION_6: "Check for poor contact in “vampire” type connectors;",
  HIGH_RESISTANCE_SUGGESTION_7: "Check for crushed cables, which would increase cable resistance.",

  HIGH_RESISTANCE_SUGGESTION_8: "This check can be performed while the network is operating; however, for any intervention it is recommended to wait for a shutdown, as these changes may bring down the network.",

  // ---------------------------- A NOT OK ----------------------------
  A_NOT_OK_SUGGESTION_1: "When there is a short between conductor A and the shield, the suggestion is to:",
  A_NOT_OK_SUGGESTION_2: "Perform a visual inspection:",
  A_NOT_OK_SUGGESTION_3: "Inside the connectors, checking whether there is a short between conductor A and the shield;",
  A_NOT_OK_SUGGESTION_4: "Throughout the entire segment, checking whether any cable section is damaged, crushed in a cable tray, cut at a conduit outlet, or crushed by an MCC drawer, etc.",

  // ---------------------------- B NOT OK ----------------------------
  B_NOT_OK_SUGGESTION_1: "When there is a short between conductor B and the shield, the suggestion is to:",
  B_NOT_OK_SUGGESTION_2: "Perform a visual inspection:",
  B_NOT_OK_SUGGESTION_3: "Inside the connectors, checking whether there is a short between conductor B and the shield;",
  B_NOT_OK_SUGGESTION_4: "Throughout the entire segment, checking whether any cable section is damaged, crushed in a cable tray, cut at a conduit outlet, or crushed by an MCC drawer, etc.",

  // ---------------------------- LONG CABLE ----------------------------
  LONG_CABLE_SUGGESTION_1: "When the cable is too long, the suggestion is to:",
  LONG_CABLE_SUGGESTION_2: "Perform a visual inspection of the segment and check whether the bus is too long for the baud rate (communication rate), according to the table below.",
  LONG_CABLE_SUGGESTION_3: "If the segment is longer than allowed, it is suggested to insert a repeater or optic fiber link, splitting the segment.",

  BAUD_RATE_: "Baud rate",
  LENGTH: "Length",
  NINE_SIX_KBITS: "9.6 kbit/s",
  NINETEEN_KBITS: "19.2 kbit/s",
  FORTY_FIVE_KBITS: "45.45 kbit/s",
  NINETY_THREE_KBITS: "93.75 kbit/s",
  HUN_EIGHTY_SEVEN_KBITS: "187.5 kbit/s",
  FIVE_HUNDRED_KBITS: "500.0 kbit/s",
  ONE_FIVE_KBITS: "1.5 Mbit/s",
  THREE_MBPS: "3.0 Mbit/s",
  SIX_MBPS: "6.0 Mbit/s",
  TWELVE_MBPS: "12.0 Mbit/s",

  // ---------------------------- NOISE ----------------------------
  NOISE_SUGGESTION_1: "When there is noise or low insulation (leakage to ground), the suggestion is to:",
  NOISE_SUGGESTION_2: "3 tips tend to help solve this problem:",
  NOISE_SUGGESTION_3: "To attenuate noise, it is necessary to check whether all slaves on the network are properly grounded;",
  NOISE_SUGGESTION_4: "It is necessary to check the equipotential bonding of the grounding system. A simple way is to check for leakage current in the PROFIBUS cables. A value below 100mA is expected;",
  NOISE_SUGGESTION_5: "Check the insulation of the slave interfaces. A simple way is to disconnect the slaves from the segment one by one and check on TS Scope whether the problem persists, that is, whether the signals in the Live List stabilize as GOOD).",
  NOISE_SUGGESTION_6: "If the problem persists after these tips, we recommend looking for a PROFIBUS network specialist.",

  // ---------------------------- REFLECTION ----------------------------
  REFLECTION_SUGGESTION_1: "When there is reflection in the waveform, the suggestion is to:",
  REFLECTION_SUGGESTION_2: "This event is almost always associated with a lack of termination on the network, so it should be visually checked:",

  REFLECTION_SUGGESTION_3: "Whether the terminators at both ends of the segment are in the “on” position;",
  REFLECTION_SUGGESTION_4: "If PROFIBUS connectors are not used, check whether there is an active terminator at both ends;",
  REFLECTION_SUGGESTION_5: "If there is no terminator at one of the ends, it must be installed.",

  REFLECTION_SUGGESTION_6: "However, reflection can also result from a cable splice, use of unsuitable terminals, crushed cables, a change in cable type, use of an M12 splice, or any other change in the physical communication medium.",
  REFLECTION_SUGGESTION_7: "In these cases, a detailed visual inspection of the indicated network segment is required.",

  VOLTAGE_: "Voltage",

  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "When an optic fiber link with voltage level failure is detected, the suggestion is to visually check:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "The fiber link power supply;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Check the condition of the optical fibers.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "It is suggested to consult the fiber link manufacturer's manual to check the appropriate voltage level.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "When a fiber optic link with a severe voltage-level fault is detected, it is suggested to visually check:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "The fiber link power supply;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Check the condition of the optical fibers.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "It is suggested to consult the fiber link manufacturer's manual to check the appropriate voltage level.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_SUGGESTION_1: "When a relay fault signal is detected on the fiber optic link, it is suggested to visually check:",

  FIBER_SIGNAL_LOSS_SUGGESTION_2: "The fiber link power supply;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Check the condition of the optical fibers.",

  // ---------------------------- EXPERT REPORT ----------------------------
  SAVE_ACTIONS_LIST: "Save actions list",
  ACTIONS_LIST_FILENAME_PART: "Action list - TS Scope DP",

  TERMINATION_OFF_PAGE_TITLE: ". - Terminator in OFF position",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminator without power supply",
  HIGH_RESISTANCE_PAGE_TITLE: ". - Attenuated signal",
  A_NOT_OK_PAGE_TITLE: ". - Short between conductor A and the shield",
  B_NOT_OK_PAGE_TITLE: ". - Short between conductor B and the shield",
  LONG_CABLE_PAGE_TITLE: ". - Long cable",
  NOISE_PAGE_TITLE: ". - Noise or low insulation (leakage to ground)",
  REFLECTION_PAGE_TITLE: ". - Waveform reflection",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Optic fiber link – Voltage level failure (Action Required)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Optic fiber link – Voltage level failure (Urgent Action)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Optic fiber link – Relay failure",

  TERMINATION_OFF_DOTS: "..............................................................................................................",
  NO_POWER_SUPPLY_DOTS: "....................................................................................................",
  HIGH_RESISTANCE_DOTS: "............................................................................................................................",
  A_NOT_OK_DOTS: "...........................................................................................",
  B_NOT_OK_DOTS: "...........................................................................................",
  LONG_CABLE_DOTS: "..................................................................................................................................",
  NOISE_DOTS: ".................................................................................",
  REFLECTION_DOTS: "......................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: "...............................................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: "...................................................................",
  FIBER_SIGNAL_LOSS_DOTS: "..........................................................................................................",

  DISCLAIMER_EXPERT_DOTS: ".......................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "...............................................................................................................................",

  SUGGESTION: "Suggested action",
  EVIDENCE: "Evidence",
  EVIDENCE_SINGULAR: "Evidence",
  EVIDENCE_DESCRIPTION: "Evidence capture of the nonconformity reported by TS Expert:",

  TERMINATION_OFF_PAGE_DESCRIPTION: "TS Expert is indicating a possible missing terminator on the network.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "TS Expert is indicating a possible lack of power supply to the terminator.",
  HIGH_RESISTANCE_PAGE_DESCRIPTION: "TS Expert is indicating possible excess terminators or high resistance on the PROFIBUS bus.",
  A_NOT_OK_PAGE_DESCRIPTION: "TS Expert is indicating a possible short circuit between conductor A and the shield braid or the grounded mass of a panel or slave.",
  B_NOT_OK_PAGE_DESCRIPTION: "TS Expert is indicating a possible short circuit between conductor B and the shield braid or the grounded mass of a panel or slave.",
  LONG_CABLE_PAGE_DESCRIPTION: "TS Expert is indicating a possible bus condition with a length greater than allowed.",
  NOISE_PAGE_DESCRIPTION: "TS Expert is indicating a possible noise condition on the PROFIBUS network.",
  REFLECTION_PAGE_DESCRIPTION: "TS Expert is indicating the presence of reflection in the waveform.",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with voltage level failure.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with voltage level failure.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with relay failure",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "WLAN Adapter",
  WLAN_CONFIG: "WLAN Settings",
  CONNECTION_STATUS: "Connection status",

  WLAN_ADAPTER_ON: "On",
  WLAN_ADAPTER_OFF: "Off",

  IP_PLACEHODLER: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Signal strength",
  FREQUENCY: "Frequency",
  CHANNEL: "Channel",
  QUALITY: "Quality",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Quality",

  TURNING_WLAN_OFF_WAITING: "Turning off WLAN adapter, please wait.",
  TURNING_WLAN_ON_WAITING: "Turning on WLAN adapter, please wait.",

  NETWORK: "Network",
  NETWORK_NAME_1: "Network name",
  SUBMASK: "Mask",
  PASSWORD: "Password",

  ALTER_SCOPE_WLAN_CONFIG: "Are you sure you want to change the TS Scope DP WLAN settings?",

  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",

  WLAN_STATUS_POPUP_1: "Indicates the status of the TS Scope DP WLAN adapter.",
  WLAN_STATUS_POPUP_2: "If it is off, it is not possible to change the WLAN settings.",

  CONNECTION_STATUS_POPUP_1: "Indicates whether the TS Scope DP is connected to the configured WLAN network.",

  WLAN_CONFIG_POPUP_1: "Settings cannot be changed while the WLAN adapter is off.",
  WLAN_CONFIG_POPUP_2: "It is highly recommended that WLAN settings be changed only while accessing the TS Scope DP through the wired network.",
  WLAN_CONFIG_POPUP_3: "When changing the IP / mask, if the fields appear blank after the update, this is a strong indication that:",
  WLAN_CONFIG_POPUP_4: "There is already another device on the network with the same IP;",
  WLAN_CONFIG_POPUP_5: "The network mask is too restrictive and does not support the IP that was entered.",

  WLAN_ADAPTER_NOT_FOUND_1: "The TS Scope DP could not find the WLAN adapter:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Check whether the adapter is disconnected or has poor contact;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • If the adapter is neither disconnected nor has poor contact, try replacing it;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • If none of the previous options solves the problem, contact Toledo e Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modify at least one of the fields to update the WLAN settings.",
  UPDATE_WLAN_CONFIG_SUCCESS: "The WLAN settings have been updated successfully!",
  SEND_WLAN_CONFIG_WAITING: "Sending the settings, please wait. This may take about one minute.",
  LOADING_WAITING: "Loading information, please wait.",
  WLAN_INFO: "WLAN information",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "Unable to connect to the WLAN network. If the problem persists, try restarting the TS Scope DP or the WLAN router.",
  // ---------------------------- Temperature Alert ----------------------------
  IDLE_SIZE: "Idle size",
  PACKET_SIZE: "Packet size",

  SMALL: "Small",
  MEDIUM: "Medium",
  BIG: "Large",

  IDLE_SIZE_QUESTION_ICON_INFO: "The idle size refers to the number of points considered at the beginning of the device response waveform. Three different sizes can be configured:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Default idle size (Varies according to the baud rate);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Increases the size by 1 bit time;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Increases the size by 2 bit times.",

  PACKET_SIZE_QUESTION_ICON_INFO: "The packet size is the total number of points captured by TS Scope DP in a single data packet. Three different sizes can be configured:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Default packet size (Varies according to the baud rate);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Increases the packet size by 100 points;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Increases the packet size by 200 points.",

  IDLE_SIZE_WAITING: "Performing procedures to change the idle size, please wait on this screen until they finish.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "The idle size was changed successfully",
  IDLE_SIZE_CHANGE_FAILURE: "An error occurred while changing the idle size.",

  PACKET_SIZE_WAITING: "Performing procedures to change the packet size, please wait on this screen until they finish.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "The packet size was changed successfully",
  PACKET_SIZE_CHANGE_FAILURE: "An error occurred while changing the packet size.",

  REASON_DP: "Reason: ",

  // ---------------------------- Segment Devices ----------------------------
  CHECK_MASTER: "Check master",
  START_SEARCH_ERROR_MESSAGE: "An error occurred while starting the device search. Please try again.",
  SEARCH_FINISH_SUCCESS: "Device search completed successfully!",
  GET_DEVICES_LIST_ERROR: "An error occurred while loading the device list.",

  IN_SEGMENT: "Currently in segment",
  POSSIBLY_IN_SEGMENT: "Identified as belonging",
  POSSIBLY_OUT_OF_SEGMENT: "It was detected that this device may be in another segment",

  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "The information about the segment devices was sent successfully!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "An error occurred while sending the information about the segment devices.",

  SEARCH: "Search",
  SEARCH_POPUP_1: "To use TS Scope DP for the first time, it is recommended to select which devices belong to the segment.",
  SEARCH_POPUP_2: "Press the button below for TS Scope DP to search and find all reachable devices on the network.",
  SEARCH_POPUP_3_1: "After finding the devices, TS Scope DP will add them to the list of ",
  SEARCH_POPUP_3_2: "available devices",
  SEARCH_POPUP_3_3: " on the side. The available devices ",
  SEARCH_POPUP_3_4: "are all those found, whether they belong to the current network segment or not.",
  SEARCH_POPUP_4_1: "The other list, of ",
  SEARCH_POPUP_4_2: "selected devices",
  SEARCH_POPUP_4_3: ", is the list that ",
  SEARCH_POPUP_4_4: "contains the devices selected by the user that they are sure are in the current network segment.",
  SEARCH_POPUP_4_5: " Initially this list will be empty.",
  SEARCH_POPUP_5: "Once the search is done, the user must select which of these devices actually belong to the network segment, moving them from the available devices list to the selected devices list.",
  SEARCH_POPUP_6_1: "NOTE: ",
  SEARCH_POPUP_6_2: "Network masters are always monitored by TS Scope DP, therefore they do not appear on this page.",

  SAVE_POPUP_1_1: "By clicking the button below, the devices that are in the list ",
  SAVE_POPUP_1_2: "Selected devices",
  SAVE_POPUP_1_3: " will be saved.",
  SAVE_POPUP_2_1: "When performing this procedure, only the devices in the list ",
  SAVE_POPUP_2_2: "Selected devices",
  SAVE_POPUP_2_3: " will be monitored by TS Scope DP, and ",
  SAVE_POPUP_2_4: "only they will be shown on TS Scope DP screens, such as: Live List, Matrix, Oscilloscope, Bar Graph, etc.",

  EXPLANATION: "Explanation",

  SAVE_POPUP_3: "This feature is important to identify the slaves belonging to the PROFIBUS network segment. This reduces the response time since the system will be checking the relevant slaves.",
  SAVE_POPUP_4: "It is also very valuable so that those with less knowledge of the network do not look for the problem in the wrong segment.",

  AVAILABLE_DEVICES: "Available devices",
  AVAILABLE_DEVICES_POPUP_1_1: "This list contains all devices that TS Scope DP ",
  AVAILABLE_DEVICES_POPUP_1_2: "found on the network.",
  AVAILABLE_DEVICES_POPUP_2: "TS Scope DP suggests the devices it believes belong to the current network segment, indicating them as: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identified as belonging.",

  AVAILABLE_DEVICES_POPUP_3_1: "Clicking the button ",
  AVAILABLE_DEVICES_POPUP_3_2: " moves a device from the list of ",
  AVAILABLE_DEVICES_POPUP_3_3: "available devices",
  AVAILABLE_DEVICES_POPUP_3_4: " to the list of ",
  AVAILABLE_DEVICES_POPUP_3_5: "selected devices",
  AVAILABLE_DEVICES_POPUP_3_6: ", indicating that it belongs to the current network segment. After moving the devices, it is necessary to click the button ",
  AVAILABLE_DEVICES_POPUP_3_7: "Save",
  AVAILABLE_DEVICES_POPUP_3_8: " to record these changes.",

  AVAILABLE_DEVICES_POPUP_4_1: "NOTE: ",
  AVAILABLE_DEVICES_POPUP_4_2: "It is up to the user to make the final decision and decide which devices actually belong to the segment.",

  LOADING_DEVICES: "Loading devices",

  MOVE_ALL: "Move all",

  SELECTED_DEVICES: "Selected devices",

  SELECTED_DEVICES_POPUP_1_1: "This list contains all devices that the user has marked as ",
  SELECTED_DEVICES_POPUP_1_2: "belonging to the current network segment.",

  SELECTED_DEVICES_POPUP_2_1: "It is important to note that after clicking the button ",
  SELECTED_DEVICES_POPUP_2_2: "Save",
  SELECTED_DEVICES_POPUP_2_3: ", TS Scope DP ",
  SELECTED_DEVICES_POPUP_2_4: "will only monitor the devices that are in the selected devices list.",

  SELECTED_DEVICES_POPUP_3_1: "This means that:",
  SELECTED_DEVICES_POPUP_3_2: " Devices that are not in this list will not be shown on the Live List, Matrix, Oscilloscope, Bar Graph, etc. screens.",

  CONFIRM_SEARCH_START: "Are you sure you want to start the search?",

  CONFIRM_SEARCH_START_POPUP_1_1: "The device search procedure will take ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (five) minutes",
  CONFIRM_SEARCH_START_POPUP_1_3: " to be completed.",

  CONFIRM_SEARCH_START_POPUP_2_1: " During the search ",
  CONFIRM_SEARCH_START_POPUP_2_2: "several TS Scope DP internal procedures will be restarted",
  CONFIRM_SEARCH_START_POPUP_2_3: ", and for this reason it will only return to normal operation after the search is finished.",
  CONFIRM_SEARCH_START_POPUP_2_4: "NOTE:",

  SEARCHING_DEVICES: "Searching for devices.",
  PLEASE_STAY_IN_PAGE: "Please stay on the page to follow the search progress.",

  SENDING_DEVICES_INFO: "Sending device information, please wait.",

  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Active channels",
  ACTIVE_CHANNELS_POPUP_1: "Allows you to configure which TS Scope DP channels are currently active (Which channels will be used).",
  ACTIVE_CHANNELS_POPUP_2: "It is recommended to disable all channels that are not currently being used.",
  SAVING_ACTIVE_CHANNELS: "Saving active channels, please wait.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "The active channels have been saved successfully!",
  SEND_ACTIVE_CHANNELS_ERROR: "An error occurred while saving active channels",
  CANT_TURN_ALL_CHANNELS_OFF: "It is not possible to deactivate all TS Scope DP channels at the same time.\n\nAt least one of the channels must remain active.",

  CHANNEL_1: "Channel 1",
  CHANNEL_2: "Channel 2",
  CHANNEL_3: "Channel 3",
  CHANNEL_4: "Channel 4",
  CHANNEL_5: "Channel 5",

  // ---------------------------- CHANNELS TIME ----------------------------
  CHANNELS_TIME: "Channel listening interval",
  CHANNEL_TIME_PLACEHOLDER: "20",
  CHANNELS_TIME_POPUP_1: "In this section, it is possible to configure how many minutes apart TS Scope DP will listen to the data exchange on each of the channels.",
  CHANNELS_TIME_POPUP_2: "Only intervals between the following values are valid:",
  CHANNELS_TIME_POPUP_3: "The minimum listening interval is ",
  CHANNELS_TIME_POPUP_4: "The maximum listening interval is ",
  CHANNELS_TIME_POPUP_5: "(1 hour).",

  CONFIGURE_CHANNELS_TIME_SUCCESS: "The channel listening interval was configured successfully!",
  CONFIGURE_CHANNELS_TIME_ERROR: "An error occurred while sending the channel listening interval.",
  ERROR_REASON: ".\nReason: ",

  ERROR_MSG_1: "The listening interval of",
  ERROR_MSG_2: "is not valid.",

  //
  DEVICE_CHANNELS_ON: "On",
  DEVICE_CHANNELS_OFF: "Off",

  CHANNELS_AND_DEVICES: "Channels and devices",
  DEVICE_CHANNELS_POPUP: "In this section, it is possible to configure whether TS Scope DP will automatically discover which channel each device belongs to, or whether the user wants to manually define each device's channel.",

  MEASURE_UNIT: "min",
  MEASURE_UNIT_1: "minute",
  MEASURE_UNIT_2: "minutes",

  // ---------------------------- DEVICE CHANNELS ----------------------------
  CHECK_MASTER_2: "Check master",
  CHECK_MASTER_POPUP: "When master verification is enabled, TS Scope DP will automatically detect who is the master of this network segment.",

  CHANGE_MANUAL_SELECTION_QUESTION_1: "Changing the channel selection state will restart the TS Scope DP internal procedures. This procedure may take up to 3 minutes.",
  CHANGE_MANUAL_SELECTION_QUESTION_2: "After clicking yes, wait on the screen until it finishes. Are you sure you want to proceed?",

  CHANGE_VERIFY_MASTER_QUESTION_1: "Changing master verification will restart the TS Scope DP internal procedures. This procedure may take up to 3 minutes.",
  CHANGE_VERIFY_MASTER_QUESTION_2: "After clicking yes, wait on the screen until it finishes. Are you sure you want to proceed?",

  CHANGE_DEVICES_CHANNEL_QUESTION_1: "Updating the device channels will restart the TS Scope DP internal procedures. This procedure may take up to 3 minutes.",
  CHANGE_DEVICES_CHANNEL_QUESTION_2: "After clicking yes, wait on the screen until it finishes. Are you sure you want to proceed?",

  MANUAL_CHANNEL_SELECTION: "Manual channel selection",
  MANUAL_CHANNEL_SELECTION_1: "Manual selection",
  MANUAL_CHANNEL_SELECTION_2: "of channels",

  MANUAL_CHANNEL_SELECTION_POPUP_1: "When manual selection is enabled, the user can choose in the table beside it which channel each device belongs to.",
  MANUAL_CHANNEL_SELECTION_POPUP_2: "When manual selection is disabled, TS Scope DP will try to automatically discover which channel each device belongs to.",
  MANUAL_CHANNEL_SELECTION_POPUP_3: "Automatic channel discovery is only 100% reliable if the Toledo e Souza TS Hub is being used. If another hub is being used, it is recommended to manually define each device's channel.",

  ALTER_DEVICES_CHANNELS: "Update device channels",

  WARNING: "Warning",
  MANUAL_SELECTION_WARNING_MESSAGE: "While manual selection is disabled, the options beside it will be inaccessible.",
  RESTARTING_INTERNAL_PROCEDURES: "Restarting internal procedures, please wait.",
  SEND_CHANGES_FAILURE: "An error occurred while sending the changes",

  DEVICES_PER_CHANNEL_POST_SUCCESS: "The devices and their channels were saved successfully!",
  DEVICES_PER_CHANNEL_ON_POST_SUCCESS: "The manual channel device selection was changed successfully!",
  VERIFY_MASTER_POST_SUCCESS: "Master verification was changed successfully!",

  DEVICES_PER_CHANNEL_POST_ERROR: "An error occurred while sending the devices and channels.",
  DEVICES_PER_CHANNEL_ON_POST_ERROR: "An error occurred while changing manual channel selection.",
  VERIFY_MASTER_POST_ERROR: "An error occurred while changing master verification.",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Optic Fiber",
  RELAY_STATUS: "Relay status",
  RELAY_SIGNAL: "Relay signal",
  MIN: "Minimum",
  MAX: "Maximum",
  FAULT: "Fault",
  OK: "OK",
  MIN_ANALOG_VALUE: "Minimum analog value",
  MIN_LIMIT_NOT_VALID: "The minimum analog value is not valid",
  STATUS: "Status",
  MAINTENANCE_URGENT: "Urgent Maintenance Value",
  MAINTENANCE_REQUIRED: "Required Maintenance Value",
  DIVERGENCE_MAINTENANCE_VALUE: "The required maintenance value cannot be lower than the urgent maintenance value!",
  INVALID_VALUE: "Invalid Value",
  STR_LIMIT: "Up to",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Portuguese",
  ENGLISH: "English",
  SPANISH: "Spanish",
  GERMAN: "German",
  UPDATING_LANGUAGE_WAITING: "Changing language, wait a moment",
  UNABLE_TO_ALTER_LANGUAGE: "Unable to change the program's language.\n",

  UPDATES_SUCCESS: "The updates were completed successfully!",

  IP_ASSOCIATED_MONITOR: "IP of the associated monitor: ",
  PHYS_MEDIUM: "Physical Medium DP",
});